export const NavLinks = [
  { title: "Home", link: "/" },
  { title: "About Us", link: "/about_us" },
  { title: "Contact", link: "/contact_us" },
  { title: "Blog", link: "/blog" },
  { title: "Login", link: "/login" },
  { title: "SignUp", link: "/signup" },
];
